<template>
  <div @mouseleave="mouseLeave" @mouseenter="mouseEnter" class="navbar-item has-dropdown has-dropdown-with-icons" :class="{ 'is-hoverable': isNavBarMenusHoverable, 'is-active': isDropdownActive }" >
    <a @click="toggle" class="navbar-link is-arrowless">
      <slot></slot>
    </a>

    <slot name="dropdown"></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NavBarMenu',
  data() {
    return {
      isDropdownActive: false,
      isMouseIn: null,
      timeoutId: null
    }
  },
  computed: mapState('layout', [
    'isNavBarMenusHoverable',
    'navBarDropdownsForcedClose'
  ]),
  methods: {
    toggle() {
      if (!this.isNavBarMenusHoverable) {
        this.$store.commit('layout/BASIC', {
          key: 'navBarDropdownsForcedClose',
          value: this.$options._scopeId + '-' + this._uid
        })

        this.isDropdownActive = !this.isDropdownActive
      }
    },
    mouseLeave() {
      if (this.isDropdownActive) {
        this.timeoutId = setTimeout(() => {
          this.isDropdownActive = false
        }, 1500)
      }
    },
    mouseEnter() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }
    }
  },
  watch: {
    isNavBarMenusHoverable() {
      this.isDropdownActive = false
    },
    navBarDropdownsForcedClose(newVal) {
      if (newVal !== this.$options._scopeId + '-' + this._uid)
        this.isDropdownActive = false
    }
  }
}
</script>

<style scoped></style>
